import React, { useEffect, useState } from "react";
import { getRequest } from "../../CustomHttp";

function PlanCost({ shareIdAndCost, minVal = 1, children }) {
  const initialVal = parseInt(minVal, 10) || 1;

  const [packages, setPackages] = useState({});
  const [memberValue, setMemberValue] = useState(initialVal);
  const [packagePrice, setPackagePrice] = useState(0);
  const [error, setError] = useState(false);

  const onChangePackage = (value) => {
    const val = parseInt(value, 10);

    if (val < 1 || val > 60 || !packages[val]) {
      setError(true);
      return;
    }

    setError(false);
    setMemberValue(val);
    setPackagePrice(packages[val]);

    if (shareIdAndCost) {
      shareIdAndCost(val, packages[val]);
    }
  };

  const getPackages = async () => {
    const res = await getRequest("/packages");
    if (res?.data) {
      setPackages(res.data);
      const price = res.data[initialVal];
      setPackagePrice(price);
      if (shareIdAndCost) {
        shareIdAndCost(initialVal, price);
      }
    }
  };

  useEffect(() => {
        getPackages();
    }, []); 

  return (
    <div className="row fv-row mb-7">
      <div className="col-xl-4">
        <label className="form-label text-dark fs-6 fw-bolder">
          <span className="required">Member (1–60)</span>
        </label>
        <input
          className="form-control form-control-lg form-control-solid"
          type="number"
          min={1}
          max={60}
          name="package"
          value={memberValue}
          onChange={(e) => onChangePackage(e.target.value)}
        />
        {error && (
          <em className="error">
            Please enter a value between 1 and 60.
          </em>
        )}
      </div>

      <div className="col-xl-4">
        <label className="form-label text-dark fs-6 fw-bolder">
          Monthly Cost
        </label>
        <input
          className="form-control form-control-lg form-control-solid"
          placeholder="*Will be billed debited monthly from card on file"
          type="text"
          name="monthlyCost"
          value={packagePrice}
          readOnly
        />
      </div>

      {children ?? null}
    </div>
  );
}

export default PlanCost;
